<template>
  <div class="info-modal" @click.esc="close">
    <div class="info-modal-body">
      <div class="qr-title">Qr уншуулах</div>
      <div class="info-close">
        <img src="@/assets/icon/whiteclose.png" alt="" style="width: 14px" />
      </div>
      <div class="info-info">
        <div class="qr-camera">
          <img
            src="@/assets/icon/camera-border.png"
            alt=""
            style="width: 60%"
          />
        </div>
        <qrcode-stream @decode="onDecode" @init="onInit" :style="qrHeight" />
      </div>
    </div>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
        @close="close"
      ></Error>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
        @close="close"
      ></Success>
    </transition>
  </div>
</template>

<script>
import { Service } from "@/mixins/Service";
import { QrcodeStream } from "vue-qrcode-reader";
import Error from "@/views/plugin/qrError";
import Success from "@/views/plugin/qrSuccess";
export default {
  data() {
    return {
      errorModal: false,
      errorMessage: "",
      successModal: false,
      successMessage: "",
    };
  },
  components: {
    QrcodeStream,
  },
  mixins: [Service],
  methods: {
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    close() {
      this.$emit("hideQr");
    },
    RedirectLogin() {
      this.$emit("RedirectLogin");
    },
    onDecode(decodedString) {
      // console.log(decodedString, "decodedString");
      try {
        // console.log(decodedString.length, "decodedString.length");
        if (this.isNumeric(decodedString) && decodedString.length == 18) {
          this.readByQR(decodedString);
        } else {
          this.errorModal = true;
          this.errorMessage = "Буруу QR код байна.";
        }
      } catch (error) {
        this.errorModal = true;
        this.errorMessage = error.message;
      }
    },
    readByQR(qrString) {
      const readResponse = this.qrRead(qrString);
      readResponse
        .then((response) => {
          // console.log(response);
          if (response.status === 1) {
            this.successModal = true;
            this.successMessage = response.message;
          } else {
            this.errorModal = true;
            this.errorMessage = response.message;
          }
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage = error.message;
        });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        this.errorModal = true;
        this.errorMessage = error;
      }
    },
  },
  computed: {
    qrHeight() {
      return {
        height: document.documentElement.clientHeight + "px",
      };
    },
  },
  components: {
    Error,
    Success,
  },
};
</script>
<style scoped>
@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.qr-title {
  color: white;
  position: absolute;
  z-index: 999;
  text-align: center;
  width: 100%;
  margin-top: 12px;
  font-size: 16px;
  text-transform: uppercase;
}
.qr-camera img {
  animation: zoominoutsinglefeatured 1s infinite;
}
.qr-camera {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 997;
  position: absolute;
  height: 100%;
  width: 100%;
}
.qrmessage {
  position: absolute;
  z-index: 9999;
  bottom: 10%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background: white;
  padding: 10px;
  font-size: 16px;
}
.info-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
}
.info-modal-body {
  position: absolute;
  top: 0;
  width: 465px;
  height: auto;
  border-radius: 5px;
  background-color: #1660ab;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.info-modal-body div p {
  margin: 0;
  font-size: 13px;
  color: #fff;
  text-align: center;
  padding-bottom: 20px;
}
.info-modal-body .info-close img {
  width: 10px;
}

.info-modal-body .info-close {
  position: absolute;
  z-index: 999;
  top: 10px;
  right: 10px;
}
.info-modal-body img {
  width: 100%;
  cursor: pointer;
}
.info-modal-body .info-info {
  margin-top: 0;
}
@media screen and (max-width: 500px) {
  .info-modal-body {
    margin-top: 10%;
  }
}
@media screen and (max-width: 800px) {
  .info-modal-body {
    margin-top: 0;
    width: 100%;
  }
}
</style>